import api from '@api/Api';

export default {

    createImage(params) {
        return api().post(`/images`, params);
    },

}
